<template>
  <div id="anaharita" class="continer-fluid">
    <div id="harita-menu-buton" class="gizle" @click="menu_drop()" @drag="menu_drop()">MENÜ</div>
    <div id="sag-menu" v-bind:class="menu_class">
    <div class="menu-buton text-center" style="line-height: 1;" @click="menu_drop()" @drag="menu_drop()"><span><fa :icon="['fas', 'chevron-right']" /></span></div>
   
   

    <div id="menu-ic-container" class="p-4">
  <div class="menu_buton_cont">
  <div class="menu-buton-small" @click="this.menu_drop()">Haritayı Göster</div> 

 
</div>
  <p class="load-p text-center p-0  m-0 mb-5 logo-font"><span>ADALAR'IN</span>TAŞINMAZ<br>KÜLTÜR MİRASI</p>
  


  <input 
      v-model="aranan"
      placeholder="Arama yapın..." 
      style="margin-bottom: 10px; padding: 5px; width: 100%;"
    />
      <select v-if="toplam_kayit > 0" class="form-select mb-2"  v-model="ada">
      <option value=""><strong>Ada Seçin (Tüm Adalar)</strong></option>
      <option v-for="(item,index) in ada_list" :key="index">{{conv_ada(item)}}</option>
      </select>
      <select v-if="toplam_kayit > 0" class="form-select mb-2"  v-model="durum">
      <option value=""><strong>Durumu (Tümü)</strong></option>
      <option v-for="(item,index) in durum_list" :key="index">{{item}}</option>
      </select>
    

    <select v-if="toplam_kayit > 0" class="form-select mb-2"  v-model="donem">
    <option value=""><strong>Dönem (Tümü)</strong></option>
    <option :key="index" v-for="(item,index) in donem_list">{{item}}</option>
    </select>

                    
    <select v-if="toplam_kayit > 0" class="form-select  mb-2"  v-model="secilen" @change="this.git()">
    <option value=""><strong>Kayıt Seçiniz</strong> ({{toplam_kayit}} kayıt var)</option>
    <option :key="index" v-for="(item,index) in liste" :value="item.seoname">{{item.adi}}</option>
    </select>

                            
      
                            
                            <div v-if="this.aranan != '' 
                    || this.donem != ''
                    || this.ilk_kullanim != ''
                    || this.bugunku_kullanim != ''
                    || this.durum != ''
                    || this.ada != ''
                    || this.aranan != ''
                    || this.tescil != ''
                    " class="col-12">
                    <p class="pt-3"><strong>Seçilenler</strong></p>
                    <span v-on:click="this.ada='' " v-if="this.ada != ''" class="filtre-badge badge bg-warning text-dark">Ada:{{ada}} <i class="fa-solid fa-trash"></i></span>
                    <span v-on:click="this.durum='' " v-if="this.durum != ''" class="filtre-badge badge bg-warning text-dark">Durum:{{durum}} <i class="fa-solid fa-trash"></i></span>
                    <span v-on:click="this.donem='' " v-if="this.donem != ''" class="filtre-badge badge bg-warning text-dark">Donem:{{donem}} <i class="fa-solid fa-trash"></i></span>  
                    <span v-on:click="this.ilk_kullanim='' " v-if="this.ilk_kullanim != ''" class="filtre-badge badge bg-warning text-dark">İ.Kullanım: {{ilk_kullanim}} <i class="fa-solid fa-trash"></i></span>
                    <span v-on:click="this.bugunku_kullanim='' " v-if="this.bugunku_kullanim != ''" class="filtre-badge badge bg-warning text-dark">B.Kullanım:{{bugunku_kullanim}} <i class="fa-solid fa-trash"></i></span>



                    <hr>
                    <button class="btn btn-sm btn-secondary col-12 mt-3" v-on:click="aranantemizle()">Tümünü Temizle</button>
                    </div>

                    <hr>
          <div class="row rounded-3 shadow-sm p-2 gx-0 gy-0 g-0" style="background-color: rgba(255,255,255,1)">
          <div class="col-md-12 d-flex justify-content-center" style="border-bottom:solid 1px red"><p class="p-0 m-0"><strong>LEJANT</strong></p></div>
          <div class="col-4 d-flex justify-content-center"><p class="text-center" style="font-size: 0.8rem; line-height:1.2;;"><img style="width: 40px; margin-bottom: 5px;" src="https://adalarmiras.com/assets/img/map/cumhuriyet.png" alt=""><br>Cumhuriyet Dönemi</p></div>
          <div class="col-4 d-flex justify-content-center"><p class="text-center" style="font-size: 0.8rem; line-height:1.2;;"><img style="width: 40px; margin-bottom: 5px;" src="https://adalarmiras.com/assets/img/map/osmanli.png" alt=""><br>Osmanlı Dönemi</p></div>
          <div class="col-4 d-flex justify-content-center"><p class="text-center" style="font-size: 0.8rem; line-height:1.2;;"><img style="width: 40px; margin-bottom: 5px;" src="https://adalarmiras.com/assets/img/map/bizans.png" alt=""><br>Bizans<br>Dönemi</p></div>

        </div>
        <hr>
                    <select v-if="rota_listesi"  class="form-select"  v-model="rota_secilen" @change="this.rota_git()" style="padding-top: 4px">
                            <option value=""><strong>Gezi Rotaları</strong></option>
                            <option :key="index" v-for="(item,index) in rota_listesi" :value="item.seoname">{{item.adi}}</option>
                            </select>
                            
                     <copyWrite></copyWrite>



    </div>  
  </div>
    <div id="map"></div>
  </div>
   
    
    
    
  </template>
  
  
  <script>
  import axios from 'axios';
  import { Loader } from '@googlemaps/js-api-loader';
  import copyWrite from '@/components/CopyWrite.vue';

  export default {
    name: 'MapView',
    components:{
      copyWrite,
    },
    data() {
    return {
        liste:[],
      map: null,
      markers: [],
      bounds: null,
        apiKey: 'AIzaSyBoQNkYAqjV4dU4Bc8w6AJ6ttVfTZGeCII', // Google Maps API anahtarınızı buraya ekleyin
        apiUrl: 'https://api2.adalarvakfi.org/mimarimiras/mmvtlist.api', // Veriyi çekeceğiniz API URL'ini buraya ekleyin
        infoWindow: null, // InfoWindow nesnesini burada tanımlıyoruz
        case:"all",
        aranan:"",
        ada:'',
        toplam_kayit:0,
        ada_list:"",
        donem:"",
        secilen:"",
        durum:"",
        orijinal_yapi:"",
        ilk_kullanim:"",
        bugunku_kullanim:"",
        tescil:"",
        siralama:"",
        //tescil_list:"",
        menu_class:"acik",
        rota_listesi:[],
        rota_secilen:""
    } 
  },
  async mounted() {

    const loader = new Loader({
        apiKey: this.apiKey,
        version: "weekly",
        libraries: ["places"],
      });

/*
    const loader = new Loader({
      apiKey: this.apiKey,
      version: 'weekly'
    });

    */

    try {
     await loader.importLibrary('maps')
        .then(async ({Map}) => {
          const map = new Map(document.getElementById("map"));
          const {AdvancedMarkerElement} = await loader.importLibrary('marker');
          new AdvancedMarkerElement({map});
        })
        await this.DataGetir("all");
        await this.initializeMap();
     
    } catch (error) {
      console.error('Error loading Google Maps:', error);
    }
  },
  watch: {
    aranan: { handler: function (val, oldVal) { if(oldVal != val){ this.DataGetir("ara"); this.initializeMap();} }, deep: true },
    ada: { handler: function (val, oldVal) { if(oldVal != val){this.DataGetir("ara"); this.initializeMap();} }, deep: true },
    durum: { handler: function (val, oldVal) { if(oldVal != val){ this.DataGetir("ara"); this.initializeMap(); } }, deep: true },
    donem: { handler: function (val, oldVal) { if(oldVal != val){ this.DataGetir("ara"); this.initializeMap(); } }, deep: true },
    orijinal_yapi: { handler: function (val, oldVal) { if(oldVal != val){ this.DataGetir("ara"); this.initializeMap(); } }, deep: true },
    ilk_kullanim: { handler: function (val, oldVal) { if(oldVal != val){ this.DataGetir("ara"); this.initializeMap(); } }, deep: true },
    bugunku_kullanim: { handler: function (val, oldVal) { if(oldVal != val){ this.DataGetir("ara"); this.initializeMap(); } }, deep: true },
  },
  created(){
    this.rota_listesi_getir()
    this.updateMetaTags()
  },
  methods: {
    initializeMap() {
      this.map = new window.google.maps.Map(document.getElementById('map'), {
        center: { lat: 40.861678298844936, lng: 29.127673217613225 },
        zoom: 14,
        mapId: "cbb5a3caa190b7f0",
        mapStyleId: "2d3b4acf7722ee7c"
      });
      this.bounds = new window.google.maps.LatLngBounds();
      this.infoWindow = new window.google.maps.InfoWindow(); // InfoWindow nesnesini burada oluşturuyoruz
  
    },
    rota_listesi_getir:function(){
      const formData = new FormData();
          formData.append("islem", 'rota_listesi');
          axios({
               method: "post",
               responseType: "json",
               url: "https://api2.adalarvakfi.org/mimarimiras/mmvtlist.api",
               data: formData
           }).then((response) => {
          
          this.rota_listesi = response.data.liste;
           })
           
    },
    DataGetir(islem) {
       
            //const response = await axios.get(this.apiUrl);
          const formData = new FormData();
          formData.append("islem", islem);
          formData.append("aranan", this.aranan);
          formData.append("ada", this.conv_ada_id(this.ada));
          formData.append("durum", this.durum);
          formData.append("donem", this.donem);
          formData.append("tescil", this.tescil);
          formData.append("orijinal_yapi", this.orijinal_yapi);
          formData.append("ilk_kullanim", this.ilk_kullanim);
          formData.append("bugunku_kullanim", this.bugunku_kullanim);
          formData.append("siralama", this.siralama);
          axios({
               method: "post",
               responseType: "json",
               url: "https://api2.adalarvakfi.org/mimarimiras/mmvtlist.api",
               data: formData
           }).then((response) => {
          
          this.liste = response.data.liste;
          this.toplam_kayit = response.data.toplam_kayit;
          

          response.data.liste.forEach(item => {
            const position = { lat: Number(item.enlem), lng: Number(item.boylam) }; // position burada tanımlanıyor
            var marker_icon
            if (item.donem == "Cumhuriyet"){ marker_icon = 'https://adalarmiras.com/assets/img/map/cumhuriyet.png'}
            else if (item.donem == "Osmanlı"){ marker_icon = 'https://adalarmiras.com/assets/img/map/osmanli.png'}
            else if (item.donem == "Bizans"){ marker_icon = 'https://adalarmiras.com/assets/img/map/bizans.png'}
            else { marker_icon = 'https://adalarmiras.com/assets/img/map/cumhuriyet.png'}
            const marker = new window.google.maps.Marker({
             
              map: this.map,
              icon: marker_icon, // Kendi marker imajınızı buraya ekleyin
              title: item.adi,
              position: position,
              
            });
            
            this.bounds.extend(position); // position kullanımı burada
            marker.addListener('click', () => {
              this.map.setZoom(18);
              this.map.setCenter(marker.getPosition());
              // InfoWindow'u göster
              this.infoWindow.setContent(`<div><h1>${item.adi}</h1><p class="aciklama">${item.aciklama.replaceAll(`\\'`,`'`)}</p><div class="row p-0 m-0 d-flex justify-content-right"><a style="width:content-only; background-color:#cdcdcd" href="/detay/${item.ada_id}/${item.seoname}" target="_self" class="btn">Detaylar</a></div></div>`);
              this.infoWindow.open(this.map, marker);
            });
                  
            this.markers.push(marker);
          });
          const styledMapType = new window.google.maps.StyledMapType(
          [
            {
              "featureType": "landscape.man_made",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#3ca9d7"
                }
              ]
            },
            {
              "featureType": "landscape.man_made",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape.natural",
              "stylers": [
                {
                  "color": "#7dbe79"
                }
              ]
            },
            {
              "featureType": "poi.business",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.government",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.medical",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "stylers": [
                {
                  "color": "#74bd65"
                }
              ]
            },
            {
              "featureType": "transit",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#70d0d7"
                }
              ]
            }
          ],
          { name: "Adalar" }
        );



        
                
                this.map.mapTypes.set("styled_map", styledMapType);
                this.map.setMapTypeId("styled_map");
                this.map.fitBounds(this.bounds);
                this.map.panToBounds(this.bounds); 



               /* function getUniqueAda() {
                var ada_arr = response.data.liste.map(x => x.ada_id).filter((v,i,s) => s.indexOf(v) === i);
                return ada_arr.sort((c, d) => c.localeCompare(d) );
                }*/
                this.ada_list =  this.arr_tekil(response.data.liste, 'ada_id');
                this.durum_list = this.arr_tekil(response.data.liste, 'durumu');
                this.donem_list =  this.arr_tekil(response.data.liste, 'donem');
                this.ilk_kullanim_list = this.arr_tekil(response.data.liste, 'kullanim_amaci');
                this.bugunku_kullanim_list = this.arr_tekil(response.data.liste, 'bugunku_kullanim');

                //this.tescil_list = this.arr_tekil(response.data.liste, 'tescil');
                /*
                var islem_arr = [];
                tescil_list_islem.forEach(function(element){ var data = element;
                if(data == "" || data == "-"){ data = "Bilinmiyor"; } else {data = "Tescilli";}

                if(!islem_arr.find(element => element === data)){ islem_arr.push(data); } });
                this.tescil_list = islem_arr;
                */


        }, (error) => {
               console.error(error)
           });
      },
      arr_tekil:function(list,aranan){
        let funcStr = "list.map(x => x."+aranan+").filter((v,i,s) => s.indexOf(v) === i)";
        var ada_arr = eval(funcStr);
        var short_a_z = ada_arr.sort(function(a, b){
        if(a.firstname < b.firstname) { return -1; }
        if(a.firstname > b.firstname) { return 1; }
            return 0;
        })
        return short_a_z
      },
      conv_bilinmiyor:function(data, arry){
        var islem_arr = [];
        let funcStr = arry+`.forEach(function(element){ var `+data+` = element;
                if(`+data+` == "" || `+data+` == "-"){ `+data+` = "Bilinmiyor"; } else {`+data+` = "Tescilli";}
                if(!`+islem_arr+`.find(element => element === `+data+`)){ `+islem_arr+`.push(`+data+`); } });`
        eval(funcStr); 
        let this_data = "this."+arry+"_list = islem_arr" 
         return this_data
      },
      conv_ada:function(data){
        var sonuc;
        if(data == "1"){ sonuc = "Büyükada"}
        if(data == "2"){ sonuc = "Heybeliada"}
        if(data == "3"){ sonuc = "Burgazada"}
        return sonuc;
      },
      conv_ada_id:function(data){
        var ada_id = "0";
        if(data == "Büyükada"){ ada_id = "1"}
        if(data == "Heybeliada"){ ada_id = "2"}
        if(data == "Burgazada"){ ada_id = "3"}
        return ada_id;
      },

     updateMetaTags: function() {
     

      
      let ogDescriptionMetaTag = document.querySelector('meta[property="og:description"]');
      
      
      ogDescriptionMetaTag.setAttribute('content', 'Adalar Müzesi tarafından "Adalar\'ın Kültür Mirası" projesi kapsamında hazırlanmıştır.')

    },
      seodan_ada_bul: function(isim) {
        const kisi = this.liste.find(k => k.seoname === isim);
        return kisi ? kisi.ada_id : null; // Eğer kişi bulunursa yaşı, bulunamazsa null döndür
      },
      git:function(){
       console.log(this.secilen)
       location.href="https://adalarmiras.com/detay/"+this.seodan_ada_bul(this.secilen)+"/"+this.secilen
      },
      rota_git:function(){
       
       location.href="https://adalarmiras.com/gezi-rotalari/"+this.rota_secilen
      },
        aranantemizle:function(){
          this.aranan = "";
          this.secilen = "";
          this.ada = "";
          this.durum = "";
          this.donem = "";
          this.orijinal_yapi = "";
          this.ilk_kullanim = "";
          this.bugunku_kullanim="";
          this.tescil = "";
        },
        menu_drop:function(){
         let durum = this.menu_class;
        
         if(durum === "acik") {  
          document.getElementById("menu-ic-container").classList.remove('slit-in-vertical');
         
          setTimeout(() => {
            
            document.getElementById("menu-ic-container").classList.add('slit-out-vertical');
                setTimeout(() => {
                  this.menu_class = "kapali"
                  setTimeout(() => {
                  document.getElementById("harita-menu-buton").classList.remove('gizle');
                  }, 500);
              }, 500);
          }, 0);
         
        }



        if(durum === "kapali") {  
            
          
          

          document.getElementById("menu-ic-container").classList.remove('slit-in-vertical');
          document.getElementById("harita-menu-buton").classList.add('gizle');
       this.menu_class = "acik"
        setTimeout(() => {
                 
                  document.getElementById("menu-ic-container").classList.add('slit-in-vertical');
                  
              }, 500);
        
        }


        }
    }
  };
  </script>
  
  <style>
#harita-menu-buton{z-index: 9000; position: absolute; right: 0px; top:76px;
background-color: orangered; padding: 8px 6px;cursor: pointer;
}
.gizle{ display: none;}
.goster_blok{display: block;}
.goster_flex{display: flex;}

.tur_adi {font-size: 1.5rem; font-weight: 700;  margin-bottom: 0px !important; line-height: 1.2rem;}
.tur_adi span{ font-size:0.8rem !important; font-weight: 400; display: inline-block;}
.tur_durak {font-size: 1.3rem; font-weight: 700;  margin-bottom: 4px !important; line-height: 1.2rem; border-bottom: solid 1px black;}
.tur_aciklama{font-size:0.9rem; padding: 16px 0px; }
.tur_duraklar{font-size:0.9rem; padding: 0px; margin-bottom: 0.1rem;  }
.duraklisteul{ list-style: decimal;}
</style>
  <style scoped>

  
 #map {
    width: 100%;
    height: 100dvh;
  }
  #map h1{font-family: forma-djr-text, sans-serif !important; font-weight: 700 !important;font-size: 28px; color:var(--petrol1); }
  #map p{font-family: forma-djr-text, sans-serif !important; font-weight: 400 !important;font-size: 16px;}
  #map p.aciklama{color: rgb(0, 0, 0) !important;}
  .btn:focus {
  outline: none !important;
  outline: none -webkit-focus-ring-color !important;
  outline-offset: -2px !important;
}

#anaharita{
  position: relative;
  z-index: auto;
}

#sag-menu{
  position: absolute;
  z-index: 90;
  right: 0px;
  top:0px;
  height: 100dvh;
  background-color: rgb(255, 255, 255);
  backdrop-filter: blur(2.8rem);
  overflow: hidden;
  overflow-y: auto;
}
.acik{
  position: relative;
  transition: width 0.32s ease-in;
  width: 400px;
  transition-duration: 0.52s;
  transition-property: all;
}

.kapali{
  position: relative;
  transition: width 0.32s ease-out;
  width:0px;
  transition-duration: 0.52s;
  transition-property: all;
  
}

.menu-container{
  width: 0px;
  position: relative;
}
.menu-buton{
position: absolute;

background-color: rgb(255, 94, 0);
z-index: 999;
padding: 10px 13px;
margin: 0px;
left: 0px;
font-size: 0.78rem;
font-weight: 700;
top: 20px;  
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
}
.menu-buton > svg{
  font-size: 25px;
}



.anasayfa-menu-buton{
width:fit-content;
color: black;
text-decoration: none;
background-color: rgb(255, 94, 0);
z-index: 999;
padding: 10px 13px;
margin: 0px;
display: block;
font-size: 0.78rem;
font-weight: 700;
top: 20px;  
cursor: pointer;
margin-bottom: 36px;
}


.menu-buton-small{
position: absolute;

background-color: rgb(255, 94, 0);
z-index: 999;
padding: 6px 8px;
margin: 0px;
left: 20px;
top: 20px;  
display: flex;
align-items: center;
justify-content: center;
display: none;
font-size: 0.8rem;
}
.menu-buton > svg{
  font-size: 25px;
}



.logo-font{
    padding-top: 20px !important;
    font-family: "lithos-pro", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 1.4rem;
    color: var(--logo);
    cursor: pointer;
    
    }
    
.logo-font span{

    font-weight: 400;
    font-size: 0.8rem;
    display: block;

    }


    .info-container{
        display: grid;
    grid-template-areas:
    'header header'
    'image main'
    'footer footer';
    gap: 10px;
      }
      .filtre-badge{
        transition: all 0.14s;
        -webkit-transition: all 0.14s;
        cursor: pointer;
        max-width: 290px !important;
        word-wrap: break-word !important;
      }
      .filtre-badge:hover {
        transform: scale(1.05); 
        
      }

      .fade-out-bck{-webkit-animation:fade-out-bck 0.34s cubic-bezier(.25,.46,.45,.94) both;animation:fade-out-bck 0.34s cubic-bezier(.25,.46,.45,.94) both}
      @-webkit-keyframes fade-out-bck{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}100%{-webkit-transform:translateZ(-80px);transform:translateZ(-80px);opacity:0}}@keyframes fade-out-bck{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}100%{-webkit-transform:translateZ(-80px);transform:translateZ(-80px);opacity:0}}


      .slit-out-vertical{-webkit-animation:slit-out-vertical .34s ease-in both;animation:slit-out-vertical .34s ease-in both; }
      @-webkit-keyframes slit-out-vertical{0%{-webkit-transform:translateZ(0) rotateY(0);transform:translateZ(0) rotateY(0);opacity:1}54%{-webkit-transform:translateZ(-160px) rotateY(87deg);transform:translateZ(-160px) rotateY(87deg);opacity:1}100%{-webkit-transform:translateZ(-800) rotateY(90deg);transform:translateZ(-800) rotateY(90deg);opacity:0}}@keyframes slit-out-vertical{0%{-webkit-transform:translateZ(0) rotateY(0);transform:translateZ(0) rotateY(0);opacity:1}54%{-webkit-transform:translateZ(-160px) rotateY(87deg);transform:translateZ(-160px) rotateY(87deg);opacity:1}100%{-webkit-transform:translateZ(-800) rotateY(90deg);transform:translateZ(-800) rotateY(90deg);opacity:0}}

      .slit-in-vertical{-webkit-animation:slit-in-vertical .45s ease-out both;animation:slit-in-vertical .45s ease-out both}
      @-webkit-keyframes slit-in-vertical{0%{-webkit-transform:translateZ(-800) rotateY(90deg);transform:translateZ(-800) rotateY(90deg);opacity:0}54%{-webkit-transform:translateZ(-160px) rotateY(87deg);transform:translateZ(-160px) rotateY(87deg);opacity:1}100%{-webkit-transform:translateZ(0) rotateY(0);transform:translateZ(0) rotateY(0)}}@keyframes slit-in-vertical{0%{-webkit-transform:translateZ(-800) rotateY(90deg);transform:translateZ(-800) rotateY(90deg);opacity:0}54%{-webkit-transform:translateZ(-160px) rotateY(87deg);transform:translateZ(-160px) rotateY(87deg);opacity:1}100%{-webkit-transform:translateZ(0) rotateY(0);transform:translateZ(0) rotateY(0)}}

      
      
@media (min-width: 0px) and (max-width: 600px) {
    #sag-menu{
        backdrop-filter:blur(2rem);
        -webkit-backdrop-filter: blur(2.8rem);
        backdrop-filter: blur(2.8rem);
        background-color: rgba(195, 195, 195,0.7);
      }

.acik{
    width: 100%;
}
}
      @media (min-width: 0px) and (max-width: 600px) {
        .menu-buton{
          display:none;
        }
        .menu-buton-small{
          display:flex;
        }
}
     
.show-menu{
  display: flex !important;
}
  </style>
  
  
  